import { Severity } from '@cobliteam/common-types';

export const toSeverity = (severityStr: string) => {
  return severityStr === 'MEDIUM'
    ? Severity.MEDIUM
    : severityStr === 'HIGH'
      ? Severity.SEVERE
      : Severity.VERY_SEVERE;
};

export const toSeverityAPI = (severity: Severity) => {
  return severity === Severity.MEDIUM
    ? 'MEDIUM'
    : severity === Severity.SEVERE
      ? 'HIGH'
      : 'HIGHER';
};
